import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import { selectOptions } from './js/utilityRoutines';

export default function OptionsSelection(props) {
  const { userParams, setUserParams, showOptionsSelection, setShowOptionsSelection, setDisableGoButton, ProductOptions } = props;

  const handleChange = (event, valtyp='string') => {
		const name = event.target.name;
		const value = valtyp === 'integer' ? parseInt(event.target.value, 10) : event.target.value;
    setUserParams({...userParams, [name]: value});
	}

  return (
    <Card sx={{ boxShadow: 0, backgroundColor: (theme) => theme.palette.grey[100]  }}>
      <CardHeader
        action={ 
          <IconButton 
            aria-label="expand"
            size="small"
            tabIndex={-1}
          > 
            {showOptionsSelection ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} 
          </IconButton> 
        }
        title={
          <Typography
            component="h2"
            variant="subtitle"
            sx={{ fontSize: 16 }}
          >
            Options Selection
          </Typography>
        }
        sx={{ p: 0 }}
        onClick={() => setShowOptionsSelection(!showOptionsSelection)}
      />

      <Collapse in={showOptionsSelection} timeout="auto" unmountOnExit>
        <CardContent sx={{ p: '0 !important' }}>
          <ProductOptions
            userParams={userParams}
            setUserParams={setUserParams}
            selectOptions={selectOptions}
            handleChange={handleChange}
            setDisableGoButton={setDisableGoButton}
          />
        </CardContent>
      </Collapse>
    </Card>
  )
}